import { ThemeProvider } from "styled-components";
import { theme } from "./OLDstyles/theme";
import { HeaderWrapper, ContentWrapper, MessagesWrapper, PageWrapper, RightSide, SocialLinksWrapper, SocialsContainer, LinkMessageWrapper } from "./OLDstyles/Layouts";
import { DesktopMessage, LinkTitle, Message, Slogan, Title } from "./OLDstyles/Typography";
import { BrushStrokeBg, LogoImage, MainImage } from "./OLDstyles/Images";
import { FaInstagram, FaMeetup } from "react-icons/fa";
import { AddressLink, LinkBrushStrokeBg, SocialLink } from "./OLDstyles/Links";
import orangeBrushStroke from "./assets/images/orange-brush-stroke.png";
import blackBrushStroke from "./assets/images/black-brush-stroke.png";
import redBrushStroke from "./assets/images/red-brush-stroke.png";

function App() {
  return (
    <ThemeProvider theme={theme}>
      <PageWrapper>
        <MainImage />
        <ContentWrapper>
          <HeaderWrapper>
            <BrushStrokeBg $image={orangeBrushStroke} $padding={"3.5rem 3.5rem 6rem 3.5rem"}>
              <Title>Charcha Art Cafe</Title>
              <Slogan>Locally brewed culture. Served daily.</Slogan>
            </BrushStrokeBg>
          </HeaderWrapper>
          <RightSide>
            <LogoImage></LogoImage>
            <MessagesWrapper>
              <LinkBrushStrokeBg $image={blackBrushStroke} $padding={"4rem 3rem"} href="https://maps.app.goo.gl/tLddZn35jMnAH8zR6" target="_blank" rel="noopener noreferrer">
                <DesktopMessage>Website Coming Soon</DesktopMessage>
                <DesktopMessage>In the meantime, enjoy a cup of specialty coffee or a collection of wines.</DesktopMessage>
                {/* <AddressLink href="https://maps.app.goo.gl/tLddZn35jMnAH8zR6" target="_blank" rel="noopener noreferrer">
                  Carrer d'Avinyó, 24, Ciutat Vella, 08002 Barcelona
                </AddressLink> */}
                <Message>Carrer d'Avinyó, 24, Ciutat Vella, 08002 Barcelona</Message>
              </LinkBrushStrokeBg>
            </MessagesWrapper>
            <SocialsContainer>
              <BrushStrokeBg $image={redBrushStroke} $padding={"1.5rem 5rem 1rem 4rem"} style={{ gap: "0.8rem" }}>
                <Message>Check out our social events below.</Message>
                <SocialLinksWrapper>
                  {/* <LinkMessageWrapper>
                    <SocialLink href="https://www.instagram.com/cafe_charcha/" target="_blank" rel="noopener noreferrer">
                      <FaInstagram />
                    </SocialLink>
                    <LinkTitle>@cafe_charcha</LinkTitle>
                  </LinkMessageWrapper> */}
                  {/* <LinkMessageWrapper> */}
                  <SocialLink href="https://www.meetup.com/charcha-cultural-cafe/" target="_blank" rel="noopener noreferrer">
                    <FaMeetup />
                  </SocialLink>
                  {/* <LinkTitle>meetup</LinkTitle> */}
                  {/* </LinkMessageWrapper> */}
                  {/* <LinkMessageWrapper> */}
                  <SocialLink href="https://www.instagram.com/charchacultura/" target="_blank" rel="noopener noreferrer">
                    <FaInstagram />
                  </SocialLink>
                  {/* <LinkTitle>@charchacultura</LinkTitle> */}
                  {/* </LinkMessageWrapper> */}
                </SocialLinksWrapper>
              </BrushStrokeBg>
            </SocialsContainer>
          </RightSide>
        </ContentWrapper>
      </PageWrapper>
    </ThemeProvider>
  );
}

export default App;
